import React, { useMemo } from 'react';
import styled from 'styled-components';
import {
  IndicatorSectionKey,
  indicatorSectionsInOrder,
  stageIdToString,
} from 'npo/pages/ReportBuilder/Components/ImpactIndicator/utils';
import { parseImpactDetailsAnswer } from './FeedbackImpactDetails';
import TrueImpactDropdown from 'shared/design-system/components/TrueImpactDropdown';
import { IndicatorDetails } from 'npo/pages/ReportBuilder/Components/IndicatorDetails/utils';

export interface ModelDetails {
  indicator?: IndicatorDetails;
  sectionId?: IndicatorSectionKey;
}

interface FeedbackModelButtonsProps {
  answer: string;
  modelDetails?: ModelDetails;
  setModelDetails: React.Dispatch<React.SetStateAction<ModelDetails>>;
}

const stageOptions = indicatorSectionsInOrder.filter(x => x !== 'catalyzed');
const defaultFunction = (v: IndicatorSectionKey) => stageIdToString(v);
const StyledDiv = styled.div`
  display: flex;
  .dropdown {
    flex: 1;
    .MuiSelect-select {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
`;

const FeedbackModelButtons: React.FC<FeedbackModelButtonsProps> = ({
  answer: a,
  modelDetails,
  setModelDetails,
}) => {
  const answer = useMemo(() => parseImpactDetailsAnswer(a), [a]);

  const handleIndicatorChange = (i: IndicatorDetails) => {
    setModelDetails(prev => ({ ...prev, indicator: i }));
  };

  const handleSectionChange = (id: IndicatorSectionKey) => {
    setModelDetails({ sectionId: id, indicator: undefined });
  };

  if (!answer) {
    return null;
  }

  const indicatorOptions = modelDetails?.sectionId
    ? answer[modelDetails?.sectionId]
    : [];
  return (
    <StyledDiv>
      <TrueImpactDropdown
        native={true}
        options={stageOptions}
        value={modelDetails?.sectionId}
        getId={defaultFunction}
        getLabel={defaultFunction}
        name="-- Select model stage --"
        getItemDisability={() => false}
        onChange={handleSectionChange}
        className="dropdown"
      />
      <TrueImpactDropdown
        native={true}
        options={indicatorOptions}
        disabled={!modelDetails?.sectionId}
        value={modelDetails?.indicator}
        getId={(v: IndicatorDetails) => v.indicatorId}
        getLabel={(v: IndicatorDetails) => v.indicatorName}
        renderValue={(v: IndicatorDetails) =>
          v.indicatorName || '-- Select an indicator (optional) --'
        }
        name="-- Select an indicator (optional) --"
        getItemDisability={() => false}
        onChange={handleIndicatorChange}
        className="dropdown"
      />
    </StyledDiv>
  );
};

export default FeedbackModelButtons;
